<script lang="ts" setup>
  import { Button } from '../../../../shared/ui/button';

  defineProps<{ paused: boolean; posting: boolean }>();
  defineEmits<{ toggle: [] }>();
</script>

<template>
  <Button :disabled="posting" @click="$emit('toggle')">
    {{ paused ? 'Unpause' : 'Pause' }}
  </Button>
</template>
